import { RuleOperator } from '@pdqdev/pdq-shared/dist/entities/Rules';
import {
  CheckoutExtensionUI,
  CouponType,
  DiscountRejectionCouponExtension,
} from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { capitalize } from '@utils/string-utils';
import { CheckboxConfig, DropdownFieldConfig, FormFieldConfig, RadioOption } from './model';
import { RichTextCompTextFormat } from '@app/storybook/components/rich-textarea/rich-textarea.component';

const bannerStatusOptions = [
  CheckoutExtensionUI.Appearance.INFO,
  CheckoutExtensionUI.Appearance.SUCCESS,
  CheckoutExtensionUI.Appearance.WARNING,
  CheckoutExtensionUI.Appearance.CRITICAL,
].map((value) => ({ value, label: capitalize(value) }));

const buttonAppearanceOptions = [
  CheckoutExtensionUI.Appearance.BASE,
  CheckoutExtensionUI.Appearance.MONOCHROME,
  CheckoutExtensionUI.Appearance.CRITICAL,
].map((value) => ({ value, label: capitalize(value) }));

const textColorOptions = Object.values(DiscountRejectionCouponExtension.BannerTextColorOptions).map((value) => ({
  value,
  label: capitalize(value),
}));

export const widgetTypeRadioOptions: RadioOption<DiscountRejectionCouponExtension.WidgetType>[] = [
  { value: DiscountRejectionCouponExtension.WidgetType.BANNER, text: 'Banner' },
  { value: DiscountRejectionCouponExtension.WidgetType.CLICKABLE, text: 'Clickable component' },
];

export const widgetAppearanceFields: DropdownFieldConfig[] = [
  { type: 'dropdown', title: 'Banner Status', controlName: 'backgroundColor', options: bannerStatusOptions },
  { type: 'dropdown', title: 'Banner Text Color', controlName: 'textColor', options: textColorOptions },
];

export const buttonFields: FormFieldConfig[] = [
  { type: 'input', label: 'Button CTA Text', placeholder: 'Claim', controlName: 'buttonCtaText' },
  { type: 'dropdown', title: 'Button Appearance', controlName: 'buttonAppearance', options: buttonAppearanceOptions },
];

export const couponRuleRadioOptions: RadioOption<RuleOperator>[] = [
  { value: RuleOperator.IS_ALL, text: 'All Coupon Codes' },
  { value: RuleOperator.IS, text: 'Coupon Code Is' },
  { value: RuleOperator.INCLUDE, text: 'Coupon Code Includes' },
];

export const replacementRuleRadioOptions: RadioOption<DiscountRejectionCouponExtension.ReplacementRule>[] = [
  { value: DiscountRejectionCouponExtension.ReplacementRule.NO_DISCOUNT, text: 'Do Not Offer Discount' },
  { value: DiscountRejectionCouponExtension.ReplacementRule.EXISTING_DISCOUNT, text: 'Choose From Store Discounts' },
  { value: DiscountRejectionCouponExtension.ReplacementRule.CREATE_DISCOUNT, text: 'Create Unique Discount' },
];

export const couponTypeOptions = [
  { value: CouponType.PERCENTAGE, label: 'Percentage' },
  { value: CouponType.FIXED_AMOUNT, label: 'Fixed Amount' },
];

export const combinesWithCheckboxes: CheckboxConfig[] = [
  { controlName: 'combinesWithProductDiscounts', label: 'Product Discounts' },
  { controlName: 'combinesWithOrderDiscounts', label: 'Order Discounts' },
  { controlName: 'combinesWithShippingDiscounts', label: 'Shipping Discounts' },
];

export const allFormatsDisabled: RichTextCompTextFormat[] = [
  'italic',
  'bold',
  'underline',
  'strike',
  'align',
  'list',
  'header',
  'emoji',
];

export const FAILED_ATTEMPT_THRESHOLD_CONFIG = {
  DEFAULT_ENABLED: false,
  DEFAULT_LIMIT_WITHIN_TIME_WINDOW: false,
  MIN_ATTEMPTS: 2,
  DEFAULT_TIME_WINDOW_SECONDS: 30,
  DEFAULT_TIME_WINDOW_MINUTES: 5,
  MIN_TIME_WINDOW_SECONDS: 5,
  MAX_TIME_WINDOW_SECONDS: 120,
  MIN_TIME_WINDOW_MINUTES: 1,
  MAX_TIME_WINDOW_MINUTES: 180,
} as const;

export const dynamicFieldsMentionConfig = {
  items: [
    {
      name: '{customer.first_name}',
      description: 'Customer First Name',
      searchTerm: 'customer.first_name',
      replaceableName: '{customer.first_name}',
    },
    {
      name: '{customer.last_name}',
      description: 'Customer Last Name',
      searchTerm: 'customer.last_name',
      replaceableName: '{customer.last_name}',
    },
    {
      name: '{replacement_discount}',
      description: 'Replacement Discount Code',
      searchTerm: 'replacement_discount',
      replaceableName: '{replacement_discount}',
    },
  ],
  triggerChar: '{',
  labelKey: 'description',
  descriptionKey: 'name',
  filterByKey: 'searchTerm',
  removeTriggerCharOnSelect: true,
};
